import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export type Booking = {
  date: string;
  cabId: string;
  referenceNo?: string;
  paymentMode: string;
  amount: number;
};

const initialState: any = {
  data: [],
  loading: false,
  error: null,
  update: { updating: false, success: false },
};
const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    fetchBookingRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBookingSuccess(state, action) {
     state.data = action.payload.data;
      state.totalFare = action.payload.totalFare;
      state.datacount = action.payload.datacount;
      state.loading = false;
    },
    fetchBookingFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCompanyRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCompanySuccess(state, action: PayloadAction<Booking[]>) {
      state.loading = false;
      state.comdata = action.payload;
    },
    fetchCompanyFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateCompanyRequest(state) {
      state.update = { updating: true, success: false };
    },
    updateCompanySuccess(state: any, action) {
      state.update = { updating: false, success: true, };
    },
    updateCompanyFailure(state, action) {
      state.update = { updating: false, success: false };
    },
    updatePrepaidRequest(state) {
      state.update = { updating: true, success: false };
    },
    updatePrepaidSuccess(state: any, action) {
      state.update = { updating: false, success: true, };
    },
    updatePrepaidFailure(state, action) {
      state.update = { updating: false, success: false };
    },
    resetUpdateState(state) {
      state.update = { creating: false, success: false };
    },
  },
});
export const {
  fetchBookingRequest,
  fetchBookingSuccess,
  fetchBookingFailure,
  fetchCompanyRequest,
  fetchCompanySuccess,
  fetchCompanyFailure,
  updateCompanyRequest,
  updateCompanySuccess,
  updateCompanyFailure,
  updatePrepaidRequest,
  updatePrepaidSuccess,
  updatePrepaidFailure,
  //   resetUpdateState,
} = bookingSlice.actions;
export default bookingSlice.reducer;
